<div class="modal-body conditionModal__body confirmModal__body p-4">
  <p class="d-flex align-items-center
  fs fs__md">
    <ion-icon name="information-circle" class="ion-3x color-yellow mr-2"></ion-icon>
    Please save rating before moving to next section.
  </p>
</div>

<div class="modal-footer conditionModal__footer">
  <div class="conditionModal__footerInner p-0">
    <div class="row w-100 mx-0">
      <div class="col-md-8 ml-sm-auto px-0">
        <div class="conditionModal__btnGrp">
          <button type="button" 
            class="btn btn__primary w-100 mr-1"
            [disabled]="saving || !overAllCheck"
            (click)="saveData()"
            *ngIf="!apiError">
            Save
            <span class="spinner-grow 
              spinner-grow-sm 
              text-light ml-2" [hidden]="!saving">
            </span>
            <span class="spinner-border 
              spinner-border-sm 
              text-light ml-2" [hidden]="overAllCheck">
            </span>
          </button>
          <button type="button" 
            class="btn btn__secondary w-100 ml-1"
            (click)="modal.hide()">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
